(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/utils/campaign-utils.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/utils/campaign-utils.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const CAMPAIGN_STORAGE_KEY = 'lyckoplatsenCampaign';
const hasItems = response => {
  var _response$items;
  return Boolean(response === null || response === void 0 || (_response$items = response.items) === null || _response$items === void 0 ? void 0 : _response$items.length);
};
const hasWagers = response => {
  var _response$wagers;
  return Boolean(response === null || response === void 0 || (_response$wagers = response.wagers) === null || _response$wagers === void 0 ? void 0 : _response$wagers.length);
};
const showCampaignTermsDialog = () => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'help-2',
    title: 'Kampanjvillkor',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.LEFT,
      text: '<ul>' + '<li>Gäller dig som inte tidigare spelat eller rättat lotter online hos Svenska Spel Tur.</li>' + '<li>Din första spelprodukt hos oss behöver vara en prenumeration på Lyckoplatsen.</li>' + '<li>Prenumerationen kostar 40 kr/vecka och betalas månadsvis i förskott (första betalningen är 160 kr-240 kr beroende på startdatum).</li>' + '<li>Kampanjen gäller 29 maj-15 juni 2026.</li>' + '<li>Trisslotterna skickas via mejl inom tio dagar efter att prenumerationen startats.</li>' + '<li>För att ta del av erbjudandet behöver du ha en verifierad e-postadress.</li>' + '</ul>'
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showCampaignNotAvailableDialog = () => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'help-2',
    title: 'Tyvärr kan du inte ta del av det här erbjudandet',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: 'Eftersom du redan har spelat hos oss gäller inte nykundserbjudandet för dig. Du är varmt välkommen att spela ändå, men utan välkomstgåva.'
    }],
    actions: [{
      title: 'Till startsidan',
      callback: () => {
        dialog.close(() => {
          svs.utils.url.navigate(svs.core.urlMapping.get('lyckoplatsenHome'));
        });
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const hasCampaignRecord = async () => {
  const _await$svs$tur$apiCal = await svs.tur.apiCaller.drawgames.getPlayerObjectstore({
      keys: CAMPAIGN_STORAGE_KEY
    }),
    response = _await$svs$tur$apiCal.response;
  svs.lyckoplatsen.logger.debug('Checking campaign record in object store, response:', response);
  return hasItems(response);
};
const runCampaignEligibilityCheck = async (check, errorMessage) => {
  try {
    return await check();
  } catch (error) {
    svs.lyckoplatsen.logger.error(errorMessage, error);
    return false;
  }
};
const hasActiveOrFinishedWagers = async () => {
  const _await$Promise$all = await Promise.all([runCampaignEligibilityCheck(async () => {
      const _await$svs$tur$apiCal2 = await svs.tur.apiCaller.drawgames.getPlayerActiveWagers({
          count: 1
        }),
        response = _await$svs$tur$apiCal2.response;
      svs.lyckoplatsen.logger.debug('Checking active wagers for campaign eligibility, response:', response);
      return hasWagers(response);
    }, 'Failed to validate active campaign wagers'), runCampaignEligibilityCheck(async () => {
      const _await$svs$tur$apiCal3 = await svs.tur.apiCaller.drawgames.getPlayerFinishedWagers({
          count: 1
        }),
        response = _await$svs$tur$apiCal3.response;
      svs.lyckoplatsen.logger.debug('Checking finished wagers for campaign eligibility, response:', response);
      return hasWagers(response);
    }, 'Failed to validate finished campaign wagers')]),
    _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
    userHasActiveWagers = _await$Promise$all2[0],
    userHasFinishedWagers = _await$Promise$all2[1];
  return userHasActiveWagers || userHasFinishedWagers;
};
const ensureNewCustomerCampaignEligibility = async () => {
  if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    return true;
  }
  const _await$Promise$all3 = await Promise.all([runCampaignEligibilityCheck(hasActiveOrFinishedWagers, 'Failed to validate campaign wagers'), runCampaignEligibilityCheck(hasCampaignRecord, 'Failed to retrieve campaign subscription data from object store')]),
    _await$Promise$all4 = _slicedToArray(_await$Promise$all3, 2),
    userHasWagers = _await$Promise$all4[0],
    userHasCampaignRecord = _await$Promise$all4[1];
  if (userHasWagers || userHasCampaignRecord) {
    return false;
  }
  return true;
};
setGlobal('svs.lyckoplatsen.components.page_play.utils', {
  ensureNewCustomerCampaignEligibility,
  showCampaignNotAvailableDialog,
  showCampaignTermsDialog
});

 })(window);